import { createContext, useContext, useState } from "react";

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("public");
  const [activeConv, setActiveConv] = useState(null);
  const [requestCount, setRequestCount] = useState(0);

  const openDm = (convId) => {
    setActiveConv(convId);
    setTab("dm");
    setOpen(true);
  };

  return (
    <ChatContext.Provider value={{ open, setOpen, tab, setTab, activeConv, setActiveConv, openDm, requestCount, setRequestCount }}>
      {children}
    </ChatContext.Provider>
  );
}

export const useChat = () => useContext(ChatContext);
